import { render, staticRenderFns } from "./timeType.vue?vue&type=template&id=0c023ddb&scoped=true&"
import script from "./timeType.vue?vue&type=script&lang=js&"
export * from "./timeType.vue?vue&type=script&lang=js&"
import style0 from "./timeType.vue?vue&type=style&index=0&id=0c023ddb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c023ddb",
  null
  
)

export default component.exports